import React, { useState, useEffect } from 'react';
import { useCreatingNewUserAtom } from '../../atoms/useCreatingNewUserAtom';
import { registerUser } from '../../api/authenticateAPIs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getAllRoles } from '../../api/authenticateAPIs';
import useAuth from "../../hooks/useAuth";
import '../../css/pages/create_user.css';

const CreateUser = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [t] = useTranslation('global');
  const [, setCreatingNewUser] = useCreatingNewUserAtom();
  const [roles, setRoles] = useState([]);
  const [backEndMessage, setBackEndMessage] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [pwdMatch, setPwdMatch] = useState('');
  const [formData, setFormData] = useState({
    newUserName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    roleId : ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleGoBack = () => {
    setCreatingNewUser(false);
    navigate('/');
  };

  const handleConfirmPassword = () => {
    if (formData.password != formData.confirmPassword) {
      setPwdMatch(t('passwordsDontMatch'));
    } else {
      setPwdMatch('');
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting: ', formData);
    setIsLoading(true);
    registerUser(
      formData.newUserName,
      formData.lastName,
      formData.email,
      formData.password,
      formData.roleId
    )
    .then(() => {
      setIsLoading(false);
      setBackEndMessage(t('userCreatedSuccess')); 
      navigate('/UserList');
    })
      .catch((resp) => {
        setIsLoading(false);
        
        let errorMessage = [];
        for (let i = 0; i < resp.response.data.message.length; i++) {    
          errorMessage += i + 1 + ". " + resp.response.data.message[i] + " ";
        }
        setBackEndMessage(errorMessage);
      });
  };

  useEffect(() => {
    if (auth.uri === 1) {
      getAllRoles()
      .then((data) => {
        setRoles(data);
        console.log(data);
      })
      .finally(() => setIsDataFetched(true));
    } else {
      navigate('/Unauthorized');
    }
  }, []);

  return (
    <>
    {auth.uri === 1  && isDataFetched ? 
        <div className="user_form page-wrap">
          <div className="header-title"><h1>{t('newUser')}</h1></div>
          <form onSubmit={handleSubmit} autoComplete="off" className="input-form">
            <div className="input-section">
              <div className="input-line">
                <label htmlFor="newUserName">{t('newUserName')}</label>
                <input
                  type="text"
                  id="newUserName"
                  name="newUserName"
                  value={formData.newUserName}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </div>
              <div className="input-line">
                <label htmlFor="lastName">{t('lastName')}</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </div>
            </div>
            <div className="input-section">
              <div className="input-line">
                <label htmlFor="email">{t('email')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </div>
            </div>
            <div className="input-section">
              <div className="input-line">
                <label htmlFor="password">{t('password')}</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </div>
            </div>
            <div className="input-section">
              <div className="input-line">
                <label htmlFor="confirm-password">{t('confirmPassword')}</label>
                <input
                  type="password"
                  id="confirm-password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  onKeyUp={handleConfirmPassword}
                />
              </div>
              {pwdMatch.length > 0 ? 
                <div className='confirm-pwd-msg'>
                  {pwdMatch}
                </div> 
              : null }
            </div>
            <div className='input-line'>
              <div className="selectbox-section">
              <label htmlFor="roleId">{t('role')}</label>
              <select className='selectbox-tab-like' id="roleId" name="roleId" value={formData.roleId} onChange={handleChange}>
                {roles.map((role, index) => (
                  <option key={index} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          </form>
            <div>{isLoading ? t('loading') : ''}</div>
            <div>{backEndMessage}</div>
            <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
            <button className="submit-button" type="submit" disabled={isLoading} onClick={handleSubmit}>{t('submit')}</button>
        </div> 
        : null }
    </>
    ); 
};

export default CreateUser;
